module.exports = __webpack_public_path__ + "img/qrcode.1da9a2e2.png";